/** User-facing strings: token. */
export const token = {
    metadataTitle: "Token",
    title: "Your authentication token",
    description: "This is your personal token. Use it to authenticate the opcua-relay agent that you downloaded.",
    backendNotReady: "Internal Error - backend is not ready",
    notLoggedIn: "Not Logged in",
    organisation: {
        heading: "Organisation",
        joinsBefore: "A new agent joins the organisation",
        joinsAfter: ": the one selected when you approve its on-boarding request in the browser.",
        switchHint: "To enrol it in another organisation, switch organisation in the header before approving.",
        membersBefore: "Members and other organisations are on the",
        membersAfter: "page.",
    },
    card: {
        heading: "Token",
        warning: "Treat it like a password: anyone who has it can enrol agents under your account.",
        fingerprint: "Fingerprint",
        lastRotated: "Last rotated",
        never: "Never",
        rotateHint:
            "If the token may have leaked, rotate it: the old one stops working at once. Agents already enrolled keep working.",
    },
    history: {
        heading: "Rotation history",
        empty: "The token has never been rotated.",
        by: "by {by}, new token",
        byFrom: "by {by} from {ip}, new token",
    },
    commandLine: {
        heading: "Command Line",
        intro: "Authenticate your opcua-relay agent. You only have to do this once: the token is saved in the agent's configuration file. The command below contains your token, use the copy button to get it in full.",
        reEnrolBefore: "If this agent is already enrolled and you want to enrol it again, add",
        reEnrolAfter: ":",
    },
    configFile: {
        heading: "Configuration File",
        introBefore: "Alternatively, you can add the Authentication Token to the",
        introAfter: "file in the agent's configuration directory.",
    },
    display: {
        label: "Authentication token",
        hide: "Hide token",
        show: "Show token",
    },
    command: {
        enrol: "Enrolment command",
        reEnrol: "Re-enrolment command",
        configFile: "config.json content",
    },
    rotate: {
        trigger: "Rotate token...",
        title: "Rotate your API token?",
        consequences:
            "A new token replaces this one at once. Every script and `{command} config` command using the old token stops working, and an enrolment started with it cannot complete. Enrolled agents keep working: each one uses its own credential.",
        confirm: "Rotate token",
        success: "Token rotated. The new token (fingerprint {fingerprint}) is shown on this page.",
        failedAction: "rotate the token",
    },
    copyField: {
        copyLabel: "Copy {label}",
        copy: "Copy",
        copied: "Copied",
        copyFailed: "Copy failed",
        copyFailedHint: "Copy failed. Select the text and copy it manually.",
        showFull: "Show full",
        showLess: "Show less",
    },
};
